import type { IBase, IImageBySizes } from "./base.interface";
import type { IDays, ISchedule } from "./catalog";
import type { OrderMode } from "./order.interface";

interface IHubriseConfig {
	locationId: string;
	accessToken: string;
	accountId: string;
	accountName: string;
	locationName: string;
	catalogId: string;
	catalogName: string;
	customerListId: string;
	customerListName: string;
	// Variantes de catalogue par créneau horaire (menus spéciaux des bridges) ; faux ou absent = comme avant.
	menusHorairesPlateformes?: boolean;
}

interface IExternalApiConfig {
	hubrise?: IHubriseConfig;
}

export interface IShop extends IBase {
	internalName: string;

	slug: string;

	siret: string;

	// Identité fiscale de l'assujetti (NF525, R13 en-tête 10, 11, 14, 15).
	// Portées par la fiche boutique parce que c'est elle qui alimente le
	// registre de chaque caisse (`resolveIssuer`, apps/os). Optionnelles au
	// TYPE (des milliers de fiches existent sans elles) mais EXIGÉES dès que la
	// boutique porte une caisse (`identite-fiscale.ts`, engine).
	zipCode?: string;

	city?: string;

	naf?: string;

	vatNumber?: string;

	publicName: string;

	disabled: boolean;

	description: string;

	address: string;

	location: {
		coordinates: number[];
		type: "Point";
	};

	phone: string;

	email: string;

	website: string;

	takeAwaySchedule: ISchedule;

	deliverySchedule: ISchedule;

	platformsSchedule: ISchedule;

	deliveryZones: any[];

	takeAwayTime: number;

	deliveryTime: number;

	defaultTakeAwayTime: number;

	defaultDeliveryTime: number;

	printers: any[];

	eshopMessage: string;
	skipServiceSummaryEmail?: boolean;

	isDeliveryOpen: boolean;

	isTakeawayOpen: boolean;

	externalApiConfig?: IExternalApiConfig;

	socialMediaLinks?: ISocialMediaLinks;

	productionCapacities?: IShopProductionCapacity[];

	enableDeliveryTracking?: boolean;
}

export type ISocialMediaLinks = {
	facebook: string;
	twitter: string;
	linkedin: string;
	instagram: string;
};

export interface IAdvertisement extends IBase {
	name: string;
	type: AdvertisementTypes;
	images: IImageBySizes;
	description?: string;
	disabled: boolean;
	startDate: Date;
	endDate: Date;
	url: string;
	shopIds?: IShop[];
}

export const isShopWithHubrise = (shop: Partial<IShop>): boolean => {
	return !!shop?.externalApiConfig?.hubrise?.locationId;
};

export interface IFacadeAdvertisement
	extends Pick<
		IAdvertisement,
		"_id" | "name" | "type" | "description" | "startDate" | "endDate"
	> {}

export enum AdvertisementTypes {
	DELIVERY = "DELIVERY",
	TAKEAWAY = "TAKEAWAY",
}

export interface IProductionCapacitySlot {
	start: number;
	end: number;
	maxOrders?: number;
	// Limite de produits par catégorie suivie (clé = tagId). Clé absente ou null = pas de limite
	maxProducts?: { [tagId: string]: number | null };
}

export interface IShopProductionCapacity {
	name: string;
	disabled: boolean;
	orderModes: OrderMode[];
	// Catégories (tags) dont on limite le volume de produits par créneau
	tagsIds?: string[];
	capacity: {
		[key in IDays]: IProductionCapacitySlot[];
	};
}
